// extracted by mini-css-extract-plugin
module.exports = {"buttons":"CreditorForm_buttons__18dHp","loadingBox":"CreditorForm_loadingBox__1jckG","validating":"CreditorForm_validating__2Ko9R"};